<template>
    <v-dialog v-model="display">
        <v-card class="no-padding">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Complete QA</v-toolbar-title>
            </v-toolbar>
            <v-card-text>

                <v-form @submit.prevent ref="qaForm" v-model="inputsValid">
                    <v-row class="dialog-content">

                        <v-col cols="12" md="6" offset-md="3">
                            <v-row >
                                <v-col cols="12">
                                    <v-combobox
                                        :items="lotNumbers"
                                        v-model="inputFields.QALotNumbers"
                                        multiple
                                        suffix
                                        label="Lot Numbers"
                                        hint="Lot Numbers"
                                        :rules="[rules.validateCombobox]"
                                        @change="handleEnteredItem"
                                    >
                                    </v-combobox>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="6" offset-md="3">
                            <v-row >
                                <v-col cols="12">
                                    <v-select
                                        :items="qaAppearances"
                                        v-model="inputFields.QAAppearance"
                                        label="Color / Appearance"
                                        :rules="[$rules.required]"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="6" offset-md="3" v-if="inputFields.QAAppearance === 'Other'">
                            <v-row >
                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        maxlength="2000"
                                        v-model="inputFields.QAAppearanceOther"
                                        :rules="[rules.qaAppearanceOtherRule]"
                                        label="Other Color / Appearance">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="6" offset-md="3">
                            <v-row >
                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        maxlength="2000"
                                        v-model="inputFields.QAProtocolAnalysis"
                                        :rules="[$rules.required]"
                                        label="RP-HPLC STD. PROTOCOL ANALYSIS">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="6" offset-md="3">
                            <v-row >
                                <v-col cols="12">
                                    <v-select
                                        :items="qaResults"
                                        v-model="inputFields.QAResult"
                                        label="Result"
                                        :rules="[$rules.required]"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="6" offset-md="3">
                            <v-row >
                                <v-col cols="12">
                                    <v-select
                                        :items="qaQualities"
                                        v-model="inputFields.QAQuality"
                                        label="Quality"
                                        :rules="[$rules.required]"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="6" offset-md="3">
                            <v-row >
                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        maxlength="2000"
                                        v-model="inputFields.QAComments"
                                        :rules="[$rules.required]"
                                        label="Comments">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>
                </v-form>
                
            </v-card-text>
            <v-card-actions>
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-alert text type="error" v-if="errorMessage">
                                {{errorMessage}}
                            </v-alert> 
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-row>
                                <v-col cols="6">
                                    <v-btn color="success" @click="save()" :disabled="!inputsValid" :loading="saving" block>Save</v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn color="error" @click="closeDialog" block>Cancel</v-btn>
                                </v-col>
                            </v-row>
                            <v-spacer></v-spacer>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import * as venomPoolingAPI from "@/services/venomPoolingAPI";
import validationRules from "@/helpers/validationrules";

export default {
    props: {
        display: {
            type: Boolean,
            default: false
        },
        venomLotID: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            errorMessage: "",
            saving: false,
            inputFields: {
                QAAppearance: null,
                QAAppearanceOther: null,
                QAProtocolAnalysis: null,
                QAResult: null,
                QAQuality: null,
                QAComments: null,
                QALotNumbers: null
            },
            
            inputsValid: false,
            enteredItem: true,

            rules: {
                validateCombobox:()=>{
                    if(this.inputFields.QALotNumbers != null&&this.inputFields.QALotNumbers != ''){
                        return true;
                    }
                    else{
                        return false;
                    }
                },
                qaAppearanceOtherRule: (value) => {
                    if (this.inputFields.QAAppearance === "Other") {
                        // when "Other" is selected then we must have a value here
                        return validationRules.rules.required(value);
                    }
                    else {
                        return true;
                    }
                }
            },
            lotNumbers: [
                "CAP/",
                "CCT/",
                "CCD/",
                "CCS/",
               "Other/",      
            ],
            qaResults: [
                "Certified CCT",
                "Certified CCS",
                "Certified CCD",
                "Certified CAP",
                "Not Applicable"
            ],
            qaQualities: [
                "Conforms to Proteomic Protocol for CCT",
                "Conforms to Proteomic Protocol for CCS",
                "Conforms to Proteomic Protocol for CCD",
                "Conforms to Proteomic Protocol for CAP",
                "Not Applicable"
            ],
            qaAppearances: [
                "Freeze-Dried Yellow Powder",
                "Other"
            ]
        };
    },
    methods: {
        closeDialog() {
            this.$emit("closeDialog");
        },
        resetDialog() {
            // make all of the input fields blank
            for (const prop in this.inputFields) {
                if (Object.prototype.hasOwnProperty.call(this.inputFields, prop)) {
                    this.inputFields[prop] = null;
                }
            }

            // show mandatory field messages
            this.$nextTick(() => this.$refs.qaForm.validate());
        },
        handleEnteredItem(){
            for(let item of this.inputFields.QALotNumbers){
                for(let i=0;i<this.lotNumbers.length;i++){
                    if(item.includes(this.lotNumbers[i])==true){
                        this.enteredItem = false;
                        break;
                    }
                }
                if(this.enteredItem){
                    const index = this.inputFields.QALotNumbers.indexOf(item);
                    this.inputFields.QALotNumbers[index-1] = this.inputFields.QALotNumbers[index-1]+item;
                    this.inputFields.QALotNumbers.splice(index,1);
                }
                this.enteredItem = true;
            }
        },
        async save() {
            this.errorMessage = "";
            this.saving = true;
            try {
                const data = {
                    VenomLotID: this.venomLotID,
                    IsClosed: true,
                    QAAppearance: this.inputFields.QAAppearance === "Other" ? this.inputFields.QAAppearanceOther : this.inputFields.QAAppearance,
                    QAProtocolAnalysis: this.inputFields.QAProtocolAnalysis,
                    QAResult: this.inputFields.QAResult,
                    QAQuality: this.inputFields.QAQuality,
                    QAComments: this.inputFields.QAComments,
                    QALotNumbers: this.inputFields.QALotNumbers.join(", ")
                };

                await venomPoolingAPI.saveVenomLot(data);

                this.$emit("dataUpdated");
            }
            catch (e) {
                this.errorMessage = e;
            }
            finally {
                this.saving = false;
            }
        }
    },
    watch: {
        display: {
            handler(newVal, oldVal) {
                if (newVal && !oldVal) {
                    // when the dialog is displayed, make sure we wipe any previous values in any of the fields and display the validation messages
                    this.resetDialog();
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>

</style>